import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { EMPTY, TimeoutError, catchError, timeout } from 'rxjs';
import { CustomerSessionService } from './customer-session.service';

/**
 * Restaura la sesión al arrancar sin bloquear la app: la tienda es pública, y un backend lento no debe dejar en
 * blanco ni el panel. Con marcador local se renueva con tope de 3 s; un timeout NO borra el marcador (agotarse el
 * tiempo no es no tener sesión), un rechazo real sí.
 */
function initializeCustomerSession(session: CustomerSessionService): () => Promise<void> {
  return () => {
    if (!session.hasSession()) {
      return Promise.resolve();
    }
    return session.refresh().pipe(
      timeout(3000),
      catchError((err: unknown) => {
        if (!(err instanceof TimeoutError)) {
          session.clearLocalSession();
        }
        return EMPTY;
      })
    ).toPromise().then(() => undefined);
  };
}

/** Único punto de entrada para `app.config.ts`. El interceptor (`customerHttpInterceptor`) se registra en `withInterceptors`. */
export function provideCustomerAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: APP_INITIALIZER, useFactory: initializeCustomerSession, deps: [CustomerSessionService], multi: true }
  ]);
}
